module.exports = __webpack_public_path__ + "media/images/svgs/logo_default-343f42c93ed5416a2e5084c6eed0af25.svg";